$(function() {
    var $fancyboxgallery = $('[data-fancybox^="group-"]');

    if(!$fancyboxgallery.length) return

    $.fancybox.defaults.hash = false;

    $('[data-fancybox^="group-]').each(function() {
        $(this).fancybox({
            loop: false
        });
    });
});


jQuery(document).ready(function($) {
    // Verifique se a página tem a classe 'page-template-page-about'
    if ($(".page-template-page-about").length > 0) {
        // Verifique se a classe 'sec-video' está presente
        if ($(".sec-video").length === 0) {
            // Adicione a classe 'light' ao elemento com a classe 'sec-gallery'
            $(".sec-gallery").addClass("light");
        }
    }
});
